import { render, staticRenderFns } from "./StitchImageSlider.vue?vue&type=template&id=49a62f5c&scoped=true&"
import script from "./StitchImageSlider.vue?vue&type=script&lang=js&"
export * from "./StitchImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./StitchImageSlider.vue?vue&type=style&index=0&id=49a62f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a62f5c",
  null
  
)

export default component.exports